import LotHeaderInfo from './lot-header-info';

export default LotHeaderInfo;